import { render } from "./roster_detail.vue?vue&type=template&id=39b467f6&scoped=true"
import script from "./roster_detail.vue?vue&type=script&lang=js"
export * from "./roster_detail.vue?vue&type=script&lang=js"

import "./roster_detail.vue?vue&type=style&index=0&id=39b467f6&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b467f6"]])

export default __exports__